import React from 'react';
import { LinearProgress } from '@mui/material';

import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { TableFooter } from './TableFooter';
import { TableContainer } from './TableContainer';
import { TablePagination } from './TablePagination';
import { Column, Group, ListingEvent, Pagination, RenderRowDetail, StaticSettings } from '../types';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  tableData: Data[];
  loading: boolean;
  groups?: Group<Data>[];
  pagination?: Pagination;
  maxHeight?: string;
  emptyMessage?: React.ReactNode;
  staticSettings?: StaticSettings;
  columns: Column<Data, Context>[];
  onEmit?: (event: ListingEvent, data?: unknown) => void;
  renderRowDetail?: RenderRowDetail<Data, Context>;
}

export const Table = <Data extends Record<string, any>, Context extends any = any>({
  onEmit,
  groups,
  columns,
  loading,
  context,
  tableData,
  pagination,
  maxHeight,
  emptyMessage,
  staticSettings,
  renderRowDetail,
}: Props<Data, Context>) => {
  return (
    <TableContainer columns={columns} maxHeight={maxHeight}>
      {loading && <LinearProgress color="primary" className="listing-loading" />}

      <TableHead<Data, Context> columns={columns} context={context} />

      <TableBody<Data, Context>
        groups={groups}
        onEmit={onEmit}
        loading={loading}
        columns={columns}
        context={context}
        tableData={tableData}
        emptyMessage={emptyMessage}
        staticSettings={staticSettings}
        renderRowDetail={renderRowDetail}
      />

      <TableFooter<Data, Context> columns={columns} loading={loading} tableData={tableData} context={context} />

      {pagination && <TablePagination pagination={pagination} />}
    </TableContainer>
  );
};
